(function(){
'use strict';

/* ---------- bandeau d'annonces : carrousel ---------- */
function initAnn(root){
  var items=root.querySelectorAll('.sq-ann__i');
  if(items.length<2){var n=root.querySelectorAll('.sq-ann__nav');for(var k=0;k<n.length;k++)n[k].style.visibility='hidden';return;}
  var i=0,timer=null;
  function show(x){
    i=(x+items.length)%items.length;
    for(var j=0;j<items.length;j++)items[j].classList.toggle('is-on',j===i);
  }
  function play(){stop();timer=setInterval(function(){show(i+1);},5000);}
  function stop(){if(timer){clearInterval(timer);timer=null;}}
  root.addEventListener('click',function(e){
    var b=e.target.closest('[data-sq-ann]');
    if(!b)return;
    show(i+(b.dataset.sqAnn==='next'?1:-1));play();
  });
  show(0);play();
}

/* ---------- section éditoriale à minutage ---------- */
function initTl(root){
  var rows=root.querySelectorAll('.sq-tl__row');
  if(!rows.length)return;
  var i=0,timer=null,playing=true;
  var count=root.querySelector('[data-sq-tl-count]');
  var pause=root.querySelector('[data-sq-tl="pause"]');
  function show(x){
    i=(x+rows.length)%rows.length;
    for(var j=0;j<rows.length;j++)rows[j].classList.toggle('is-on',j===i);
    if(count)count.textContent=(i+1)+' / '+rows.length;
  }
  function play(){stop();playing=true;if(pause)pause.textContent='\u2016';timer=setInterval(function(){show(i+1);},4500);}
  function stop(){if(timer){clearInterval(timer);timer=null;}}
  function halt(){stop();playing=false;if(pause)pause.textContent='\u25B6';}
  root.addEventListener('click',function(e){
    var hd=e.target.closest('.sq-tl__hd');
    if(hd){
      var r=hd.closest('.sq-tl__row');
      for(var j=0;j<rows.length;j++)if(rows[j]===r)show(j);
      halt();return;
    }
    var c=e.target.closest('[data-sq-tl]');
    if(!c)return;
    var a=c.dataset.sqTl;
    if(a==='prev'){show(i-1);halt();}
    else if(a==='next'){show(i+1);halt();}
    else if(a==='pause'){playing?halt():play();}
  });
  show(0);play();
}

/* ---------- avis : carrousel ---------- */
function initRv(root){
  var track=root.querySelector('.sq-rv__track');
  if(!track)return;
  var cards=track.querySelectorAll('.sq-rv');
  var dots=root.querySelectorAll('[data-sq-rv-dot]');
  if(!cards.length)return;
  function step(){var c=cards[0];return c.offsetWidth+12;}
  function current(){return Math.round(track.scrollLeft/step());}
  function mark(){
    var n=Math.min(current(),cards.length-1);
    for(var j=0;j<dots.length;j++)dots[j].classList.toggle('is-on',j===n);
  }
  root.addEventListener('click',function(e){
    var b=e.target.closest('[data-sq-rv]');
    if(!b)return;
    track.scrollBy({left:(b.dataset.sqRv==='next'?1:-1)*step(),behavior:'smooth'});
  });
  track.addEventListener('scroll',function(){
    clearTimeout(track._t);
    track._t=setTimeout(mark,90);
  },{passive:true});
  mark();
}

/* ---------- délégation générale ---------- */
document.addEventListener('click',function(e){
  var mb=e.target.closest('[data-sq-menu]');
  if(mb){var nv=document.querySelector('[data-sq-nav]');if(nv)nv.classList.toggle('is-open');}

  var s=e.target.closest('[data-sq-tint]');
  if(s){
    document.documentElement.style.setProperty('--sq-tint',s.dataset.sqTint);
    document.documentElement.style.setProperty('--sq-tint-soft',s.dataset.sqTintSoft||s.dataset.sqTint);
    var g=s.closest('[data-sq-swatches]');
    if(g){
      g.querySelectorAll('.sq-swatch').forEach(function(b){b.setAttribute('aria-checked',b===s?'true':'false');});
      var lbl=g.parentNode.querySelector('[data-sq-colorname]');
      if(lbl)lbl.textContent=s.getAttribute('title')||'';
    }
  }

  var t=e.target.closest('[data-sq-thumb]');
  if(t){
    var tr=t.closest('.sq-gal').querySelector('.sq-gal__track');
    if(tr)tr.scrollTo({left:tr.clientWidth*parseInt(t.dataset.sqThumb,10),behavior:'smooth'});
  }

  var f=e.target.closest('[data-sq-filter]');
  if(f){
    var wrap=f.closest('[data-sq-filters]');
    wrap.querySelectorAll('[data-sq-filter]').forEach(function(b){b.classList.toggle('sq-chip--on',b===f);});
    var key=f.dataset.sqFilter,n=0;
    document.querySelectorAll('[data-sq-item]').forEach(function(it){
      var ok=key==='all'||it.dataset.sqItem===key;it.style.display=ok?'':'none';if(ok)n++;});
    var c=document.querySelector('[data-sq-count]');if(c)c.textContent=n;
  }
});

function boot(){
  document.querySelectorAll('[data-sq-ann-root]').forEach(initAnn);
  document.querySelectorAll('[data-sq-tl-root]').forEach(initTl);
  document.querySelectorAll('[data-sq-rv-root]').forEach(initRv);
}
if(document.readyState!=='loading')boot();
else document.addEventListener('DOMContentLoaded',boot);
document.addEventListener('shopify:section:load',boot);
})();
